<template>
  <div id="app">
    <Header
      v-if="$route.path.substr(0, 5) != '/menu' && $route.path != '/'"
    ></Header>
    <div id="main">
      <router-view />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/views/_common/Header.vue";

export default {
  name: "App",
  components: {
    Header,
  },
};
</script>

<style>
#main {
  flex: 1;
}

body {
  padding: 0;
}
</style>
